//React, React Router, Formik
import React from 'react';
import DOMPurify from "dompurify";

//Material UI
import {makeStyles} from '@material-ui/core/styles';

//Redux
import {useSelector} from "react-redux";

//Assets

const useStyles = makeStyles(theme => ({
    container: {
        width: 'auto',
        maxWidth: 990,
        margin: theme.spacing(0, 'auto' ,6),
        padding: theme.spacing(0, 5.5),
        "& div": {
            wordBreak: 'break-word'
        },
    }
}));

const Privacy = () => {

    const classes = useStyles();

    const {privacy} = useSelector(state => state.termsPrivacyAndHelp.showData)

    return (
        <div className={classes.container}>
            {
                privacy && typeof window !== 'undefined' ?
                    <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(privacy)}}/> :
                    <h1>No data</h1>
            }
        </div>
    );
};

export default Privacy;
